import { UnderDevelopment } from '../../../utils/UnderDevelopment/UnderDevelopment';
import './Finance.scss';

export const Finance = () => {
    return (
        <UnderDevelopment />
    );
  };